import { useState } from 'react';
import { ErrorBoundary } from 'shared-ui';

import { fetchInneEvents } from 'api/events/events';
import { QueryKeyEnum } from 'core/global.enum';
import { InneEventsQueryKeysEnum, QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { useQuery } from 'hooks/useQuery/useQuery';
import { useSavedPagination } from 'hooks/useSavedPagination/useSavedPagination';

import { InneEvents } from './InneEvents';

export const InneEventsContainer = () => {
  const {
    storedQueries: { [QueryKeyLocalStorageEnum.EVENTS_OTHER]: inneEventsQuery },
  } = useLocaleStoreQuery();
  const [tableSearchQuery, setTableSearchQuery] = useState('');
  const [tkdSearchQuery, setTkdSearchQuery] = useState('');

  const { page, rowsPerPage, setPage, setRowsPerPage } = useSavedPagination({
    queryKey: QueryKeyLocalStorageEnum.EVENTS_OTHER,
    resetPaginationDependencyArray: [
      tableSearchQuery,
      inneEventsQuery.dataOd,
      inneEventsQuery.dataDo,
      inneEventsQuery.mod,
      inneEventsQuery.kategoria,
      inneEventsQuery.serwer,
      inneEventsQuery.tkd,
    ],
  });

  const { data: inneEventsResponse, isLoading } = useQuery(
    [QueryKeyEnum.EVENTS, 'inne', page, rowsPerPage, inneEventsQuery, tableSearchQuery],
    fetchInneEvents,
    {
      args: {
        [InneEventsQueryKeysEnum.OFFSET]: page * rowsPerPage,
        [InneEventsQueryKeysEnum.LIMIT]: rowsPerPage,
        [InneEventsQueryKeysEnum.QUERY]: tableSearchQuery,
        ...inneEventsQuery,
        [InneEventsQueryKeysEnum.CZYTNIK]: inneEventsQuery.tkd?.value,
      },
    },
  );

  return (
    <ErrorBoundary>
      <InneEvents
        inneEventsResponse={inneEventsResponse}
        isLoading={isLoading}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        page={page}
        setPage={setPage}
        setTableSearchQuery={setTableSearchQuery}
        tableSearchQuery={tableSearchQuery}
        tkdSearchQuery={tkdSearchQuery}
        setTkdSearchQuery={setTkdSearchQuery}
      />
    </ErrorBoundary>
  );
};
